import React, { useEffect, useState, createContext, useContext } from "react";
import { useQuery, useMutation } from "react-query";
import { fetchColorPalette, fetchSpecificPalette } from "../../Controllers/Color-explorer";

const Popularcolorcontext = createContext();
export const Usepopularcolorcontext = () => useContext(Popularcolorcontext);

const Usepopularcolor = () => {
    const [storeSpecificColor, setStoreSpecificColor] = useState([]);
    const [storeRandomColor, setStoreRandomColor] = useState([]);
    const [storeColorTagName, setStoreColorTagName] = useState("random");
    const [storeActiveId, setStoreActiveId] = useState(0);

    const useGetPopularColors = (queryString) =>
        useQuery(["popular-color", queryString], () => fetchColorPalette(), {
            enabled: true,
            select: (data) => data.data,
            onSuccess: (data) => {
                setStoreRandomColor(data);
            },
            cacheTime: 0
        })

    const { mutate: mutateInputValue, isLoading: dataLoader } = useMutation(
        fetchSpecificPalette,
        {
            onSuccess: (data) => {
                setStoreSpecificColor(data?.data);
            },
            onError: (err) => {
                console.log(err, "===== error");
            }
        }
    )

    const [copy, setCopy] = useState(null);

    const handleColors = (colorHexCode) => {
        const copyCode = colorHexCode;
        const text = document.createElement("textarea");
        document.body.appendChild(text);
        text.value = copyCode;
        text.select();
        document.execCommand("copy");
        document.body.removeChild(text);
        setCopy(colorHexCode);
        localStorage.setItem("Copy", copy);
        const getCopiedItem = localStorage.getItem("Copy");
        if (getCopiedItem === "null" || getCopiedItem !== "null") {
            setTimeout(function () {
                setCopy(null);
            }, 3000);
        }
    };

    return {
        useGetPopularColors,
        mutateInputValue,
        storeSpecificColor,
        dataLoader,
        storeRandomColor,
        storeColorTagName,
        setStoreColorTagName,
        storeActiveId,
        setStoreActiveId,
        copy,
        handleColors
    }
}

export function ProvidePopularColor({ children }) {
    const popularColor = Usepopularcolor();
    return <Popularcolorcontext.Provider value={popularColor}>{children}</Popularcolorcontext.Provider>
}